import {
	DriverScheduleTripTypeEnum,
	NormalizedScheduledLeg,
} from '@mopla/data-models';

const STARTED_LEG_STATES = ['EXECUTING', 'PRE_FINISHED', 'DONE'];

type TSequenceItem = Readonly<Pick<NormalizedScheduledLeg, 'ref' | 'state'>>;

/** A break is over once any leg after it has been started. Expects legs in timeline order. */
export const closeSkippedBreaks = <T extends TSequenceItem>(legs: T[]): T[] => {
	let lastStartedLegIndex = -1;

	legs.forEach((leg, i) => {
		if (
			leg.ref === DriverScheduleTripTypeEnum.LEG &&
			STARTED_LEG_STATES.includes(leg.state ?? '')
		) {
			lastStartedLegIndex = i;
		}
	});

	return legs.map((leg, i) =>
		leg.ref === DriverScheduleTripTypeEnum.BREAK && i < lastStartedLegIndex
			? { ...leg, state: 'DONE_BREAK' }
			: leg
	);
};
